import { render, staticRenderFns } from "./roam-transaction.vue?vue&type=template&id=1fd059c4"
import script from "./roam-transaction.vue?vue&type=script&lang=js"
export * from "./roam-transaction.vue?vue&type=script&lang=js"
import style0 from "./roam-transaction.vue?vue&type=style&index=0&id=1fd059c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports